export default __webpack_public_path__ + "static/media/inst_juego4.b8ad7101.png";